import environment from "web/script/modules/environment";

export interface BannerCampaign {
    name: string;
    flag: string;
    bannerImageUrl: string;
    bannerSize: BannerSize;
    bannerType: BannerType;
}

export interface BranchBannerCampaign extends BannerCampaign {
    branchLink: string;
}

export enum BannerSize {
    None = "none",
    Small = "small",
}

export enum BannerType {
    Branch = "branch",
    Native = "native",
    NoBanner = "no_banner",
}

const DEFAULT_BANNER_IMAGE =
    "https://static.lystit.com/static/n/static-img/app-download-banner/app_screen_162x300.png";
const DEFAULT_BANNER_SIZE = BannerSize.Small;

function getBannerTypeVariant(campaignName: string): BannerType {
    const bannerTypes = [BannerType.Branch, BannerType.Native, BannerType.NoBanner];
    const bannerTypeVariant = environment.getFeature(campaignName);
    if (bannerTypes.includes(bannerTypeVariant as BannerType)) {
        return bannerTypeVariant as BannerType;
    } else {
        return BannerType.NoBanner;
    }
}

export function getBannerCampaign(
    initialLandingPage: string,
    initialSubType: string
): null | BannerCampaign {
    // Do not show banner if on a profile feed
    const feedPageSubTypes = [
        "designer",
        "designer_category",
        "designer_type",
        "designer_sub_category",
    ];
    const disableBranchIOOnFeed =
        environment.getFeature("mg_du_banner_ios_to_app") &&
        environment.get("pageType") === "feed" &&
        feedPageSubTypes.includes(environment.get("pageSubType"));
    const enableBranchIO = environment.get("enable_branch_io") === true && !disableBranchIOOnFeed;

    if (!enableBranchIO) {
        return null;
    }

    let campaignName = "";
    let flag = "";
    let bannerImageUrl = DEFAULT_BANNER_IMAGE;
    let bannerSize = DEFAULT_BANNER_SIZE;
    let bannerType;

    if (environment.getFeature("enable_branch_io_feed") && initialLandingPage == "feed") {
        flag = "enable_branch_io_feed";
        campaignName = "Web to App - Feed - General";
    } else if (
        environment.getFeature("enable_branch_io_homepage") &&
        initialLandingPage == "homepage"
    ) {
        flag = "enable_branch_io_homepage";
        campaignName = "Web to App - Homepage - General";
    } else if (
        environment.getFeature("enable_branch_io_is_pdp") &&
        initialLandingPage == "product" &&
        initialSubType == "in_stock"
    ) {
        flag = "enable_branch_io_is_pdp";
        campaignName = "Web to App - In Stock PDP - General";
    } else if (
        environment.getFeature("enable_branch_io_oos_pdp") &&
        initialLandingPage == "product" &&
        initialSubType == "out_of_stock"
    ) {
        flag = "enable_branch_io_oos_pdp";
        campaignName = "Web to App - Out of Stock PDP - General";
    } else if (
        environment.getFeature("enable_branch_io_lead_return") &&
        initialLandingPage == "lead" &&
        environment.get("pageType") !== "lead"
    ) {
        flag = "enable_branch_io_lead_return";
        campaignName = "Web to App - CSS Lead Return - General";
    } else {
        return null;
    }

    bannerType = getBannerTypeVariant(flag);

    return {
        name: campaignName,
        flag: flag,
        bannerImageUrl: bannerImageUrl,
        bannerSize: bannerSize,
        bannerType: bannerType,
    };
}
